export default function PageHeader({ title, subtitle, actions }) {
    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 pb-5 border-b-2 border-emerald-200/60">
            <div className="min-w-0">
                <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 truncate tracking-tight">{title}</h1>
                {subtitle && <p className="text-slate-500 text-sm mt-1.5 truncate">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0 flex-wrap">{actions}</div>}
        </div>
    );
}
